import { DashboardApi } from '@/apis';
import RootStore from '.';
import BaseStore from './BaseStore';
import { flow, makeObservable, observable } from 'mobx';
import { ResponseData } from '@/types/http';
import { GetStatisticShopForDashboardRequest, GetStatisticViewForDashboardRequest, StatisticShopResponse, StatisticViewResponse } from '@/types/http-payload/dashboard';

export default class DashboardStore extends BaseStore {
    api: DashboardApi;
    statisticView?: StatisticViewResponse;
    statisticShop?: StatisticShopResponse;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            statisticView: observable,
            statisticShop: observable,
            getStatisticViewForDashboard: flow.bound,
            getStatisticShopForDashboard: flow.bound
        });
        this.api = new DashboardApi();
    }

    *getStatisticViewForDashboard(searchParams?: GetStatisticViewForDashboardRequest) {
        try {
            const res: ResponseData<StatisticViewResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getStatisticViewForDashboard, searchParams);
            if (res?.ok) {
                this.statisticView = res.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getStatisticShopForDashboard(searchParams?: GetStatisticShopForDashboardRequest) {
        try {
            const res: ResponseData<StatisticShopResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getStatisticShopForDashboard, searchParams);
            if (res?.ok) {
                this.statisticShop = res.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    clean(): void {
        super.clean();
        this.statisticView = undefined;
        this.statisticShop = undefined;
    }
}
